import { Injectable } from "@angular/core";
import { Router, UrlTree, ActivatedRouteSnapshot } from "@angular/router";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "./services/auth-service.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private cookieService: CookieService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const token =
      this.localStorageService.getLocalStorageItem("flexYear-token");
    const isLoginRoute = route.routeConfig?.path === "login";

    // Logged-in user hitting /login → send to role-appropriate dashboard
    if (isLoginRoute && token) {
      return this.router.createUrlTree([this._getDashboardRoute()]);
    }

    // No token on protected route → send to login
    if (!isLoginRoute && !token) {
      return this.router.createUrlTree(["/login"]);
    }

    return true;
  }

  /** Returns the correct dashboard path based on angular_role in localStorage. */
  private _getDashboardRoute(): string {
    const role = this.localStorageService.getLocalStorageItem("role");
    const isAdmin = role === "Super Admin" || role === "Admin";
    return isAdmin ? "/dashboard/admin" : "/dashboard/staff-dashboard";
  }
}
